import { ChatMessageReaction, GroupedReaction, ReactionInitiator } from 'features/chat/types';
import { UserId } from 'features/users/types';

function isLocalInitiator(
  initiator: ChatMessageReaction['initiator'],
  localUserId: UserId,
  localUserExternalId: string | undefined
): boolean {
  if (initiator.id === localUserId) {
    return true;
  }
  if (localUserExternalId) {
    return initiator.externalId === localUserExternalId || initiator.id === localUserExternalId;
  }
  return false;
}

function toInitiator(
  initiator: ChatMessageReaction['initiator'],
  local: boolean
): ReactionInitiator {
  return {
    ...initiator,
    id: initiator.externalId || initiator.id,
    userId: initiator.id,
    local,
  };
}

export const flatToGrouped = (
  reactions: ChatMessageReaction[] | undefined,
  localUserId: UserId,
  localUserExternalId?: string
): GroupedReaction[] => {
  if (!reactions) {
    return [];
  }

  const map = new Map<string, GroupedReaction>();
  for (const { emoji, initiator } of reactions) {
    const local = isLocalInitiator(initiator, localUserId, localUserExternalId);
    const value = toInitiator(initiator, local);
    const existing = map.get(emoji);
    if (existing) {
      if (!existing.initiators.some((i) => i.id === value.id)) {
        existing.initiators.push(value);
        if (local) {
          existing.localUserReacted = true;
        }
      }
    } else {
      map.set(emoji, {
        emoji,
        initiators: [value],
        localUserReacted: local,
      });
    }
  }
  return [...map.values()];
};
